import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import BackgroundSection from "./components/BackgroundSection";
import ValueSection from "./components/ValueSection";
import ActivitiesSection from "./components/ActivitiesSection";
import VisionSection from "./components/VisionSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="w-full min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <BackgroundSection />
      <ValueSection />
      <ActivitiesSection />
      <VisionSection />
      <CTASection />
      <Footer />
    </main>
  );
}
